import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tema-2.css'; // APP 2/34: UN SOLO TEMA (tokens + componentes + vidrio + «menú súper elegante»)
import { migrarAlmacen, desregistrarServiceWorker, recargarSiChunkPerdido, ArranqueSeguro } from './arranque'; // APP 2/17
import App from './App';

// APP 2/17: antes de pintar nada — llaves viejas fuera (una vez), sin service worker, chunk perdido → una recarga.
migrarAlmacen();
desregistrarServiceWorker();
recargarSiChunkPerdido();

// APP 2/20 Fase A: fuera --au-radio (nadie la leía); los radios CSS son --au-radius-sm/md/lg en styles/tema-2.css.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><ArranqueSeguro><App /></ArranqueSeguro></React.StrictMode>);
